
			<div role="main" class="main">

				<section class="page-header">
					<div class="container">
						<div class="row">
							<div class="col-md-12">
								<ul class="breadcrumb">
									<li><a href="#">Anasayfa</a></li>
									<li class="active">Mesafeli Satış Sözleşmesi</li>
								</ul>
							</div>
						</div>
						<div class="row">
							<div class="col-md-12">
								<h1>Mesafeli Satış Sözleşmesi</h1>
							</div>
						</div>
					</div>
				</section>


				<div class="container">
					<div class="row mt-xlg">
						<div class="col-md-12">
							<div style="font-size: 16px  !important;">
								<p><strong>İntestech Akıllı Çözümler Ltd. Şti. Mesafeli Satış Sözleşmesi</strong></p>

								<p>İşbu sözleşme 13.06.2003 tarih ve 25137 sayılı Resmi Gazetede yayınlanan Mesafeli Sözleşmeler Uygulama Usul ve Esasları Hakkında Yönetmelik gereği internet üzerinden gerçekleştiren satışlar için sözleşme yapılması zorunluluğuna istinaden düzenlenmiş olup, maddeler halinde aşağıdaki gibidir.</p>

								<p><strong>MADDE 1- KONU</strong></p>

								<p>İşbu sözleşmenin konusu, SATICI'nın, ALICI'ya satışını yaptığı, aşağıda nitelikleri ve satış fiyatı belirtilen ürünün satışı ve teslimi ile ilgili olarak 4077 sayılı Tüketicilerin Korunması Hakkındaki Kanun-Mesafeli Sözleşmeleri Uygulama Esas ve Usulleri Hakkında Yönetmelik hükümleri gereğince tarafların hak ve yükümlülüklerinin kapsamaktadır.</p>

                        <p><strong>MADDE 2.1 - SATICI BİLGİLERİ</strong></p>

                        <p>
                           Ünvan: İNTESTECH AKILLI ÇÖZÜMLER LTD. ŞTİ. (Bundan sonra SATICI olarak anılacaktır)
                           <br/>Adres: Cevizli Mah. Mustafa Kemal Cad. Hukukçular Towers No:66A/39 Kartal/ İstanbul
                           <br/>Telefon: (+90) 216 709 38 42
                           <br/>Email: info@intestech.com.tr</p>


                        <p><strong>MADDE 2.2 - ALICI BİLGİLERİ</strong></p>
                        <p>
                           Müşteri olarak www.intestech.com.tr sitesinden ürün alan kişi.
                           <br/>Satın alınmada kullanılan kişi ve adres bilgileri esas alınır.
                        </p>

                        <p><strong>MADDE 3- SÖZLEŞME KONUSU ÜRÜN BİLGİLERİ</strong></p>
                        <p> Malın / Ürünün / Hizmetin türü, miktarı, marka/modeli, rengi, adedi, satış bedeli, ödeme şekli, içeriği, süresi, zaman dilimi, siparişin sonlandığı andaki bilgilerden oluşmaktadır</p>


                        <p><strong>MADDE 4- GENEL HÜKÜMLER</strong></p>

                        <p> 4.1 - ALICI, Madde 3'te belirtilen sözleşme konusu ürün veya ürünlerin temel nitelikleri, satış fiyatı ve ödeme şekli ile teslimata ilişkin tüm ön bilgileri okuyup bilgi sahibi olduğunu ve elektronik ortamda gerekli teyidi verdiğini beyan eder.</p>

                        <p> 4.2 - Sözleşme konusu ürün veya ürünler, yasal 30 günlük süreyi aşmamak koşulu ile her bir ürün için ALICI'nın yerleşim yerinin uzaklıgına bağlı olarak ön bilgiler içinde açıklanan süre içinde ALICI veya gösterdiği adresteki kişi/kuruluşa teslim edilir. Bu süre ALICI’Ya daha önce bildirilmek kaydıyla en fazla 10 gün daha uzatılabilir.</p>

                        <p> 4.3 - Sözleşme konusu ürün, ALICI'dan başka bir kişi/kuruluşa teslim edilecek ise, teslim edilecek kişi/kuruluşun teslimatı kabul etmemesininden SATICI sorumlu tutulamaz.</p>

                        <p> 4.4 – SATICI, sözleşme konusu ürünün saglam, eksiksiz, siparişte belirtilen niteliklere uygun ve varsa garanti belgeleri ve kullanım klavuzları ile teslim edilmesinden sorumludur.</p>

                        <p> 4.5 - Sözleşme konusu ürünün teslimatı için işbu sözleşme ALICI'nın bu söleşmeyi kabul ederek ödemeyi yapmış olması şarttır. Herhangi bir nedenle ürün bedeli ödenmez veya banka kayıtlarında iptal edilir ise, SATICI ürünün teslimi yükümlülügünden kurtulmuş kabul edilir.</p>

                        <p> 4.6- Ürünün tesliminden sonra ALICI'ya ait kredi kartının ALICI'nın kusurundan kaynaklanmayan bir şekilde yetkisiz kişilerce haksız veya hukuka aykırı olarak kullanılması nedeni ile ilgili banka veya finans kuruluşun ürün bedelini SATICI'ya ödememesi halinde, ALICI'nın kendisine teslim edilmiş olması kaydıyla ürünün 3 gün içinde SATICI'ya gönderilmesi zorunludur. Bu takdirde nakliye giderleri ALICI'ya aittir.</p>

                        <p> 4.7-SATICI mücbir sebepler veya nakliyeyi engelleyen hava muhalefeti, ulaşımın kesilmesi gibi olağanüstü durumlar nedeni ile sözleşme konusu ürünü süresi içinde teslim edemez ise, durumu ALICI'ya bildirmekle yükümlüdür. Bu takdirde ALICI siparişin iptal edilmesini, sözleşme konusu ürünün varsa emsali ile değiştirilmesini, ve/veya teslimat süresinin engelleyici durumun ortadan kalkmasına kadar ertelenmesi haklarından birini kullanabilir. ALICI'nın siparişi iptal etmesi halinde ödedigi tutar 10 gün içinde kendisine nakten ve defaten ödenir.</p>

                        <p> 4.8- Garanti belgesi ile satılan ürünlerden olan veya olmayan ürünlerin arızalı veya bozuk olanlar, garanti şartları içinde gerekli onarımın yapılması için SATICI'ya gönderilebilir, bu takdirde kargo giderleri alıcı tarafından karşılanacaktır.</p>

                        <p> 4.9-SATICI tarafından satışı yapılan tüm ürünlerin faturaları e-posta ile gönderilmektedir. E-posta gelmediği takdirde, satış tarihinden itibaren birbirini takip eden 7 iş günü içerisinde info@sileceksepeti.com isimli mail adresimize yazılı olarak bu durumun bildirilmesi halinde, faturanız ücretsiz olarak adresinize kargolanacaktır. Satış tarihinden itibaren birbirini takip eden 7 iş günü içerisinde bildirim yapılmadığı takdirde, müşteri tarafından faturanın teslim alındığı varsayılır.</p>

                        <p> 4.10-İşbu sözleşme, ALICININ satın alma öncesinde formu onaylaması ile geçerlilik kazanır.</p>

                        <p><strong>MADDE 5- CAYMA HAKKI</strong></p>

                        <p>ALICI, sözleşme konusu ürünün kendisine tesliminden itibaren (7) gün içinde cayma hakkına sahiptir. Cayma hakkının kullanılması için bu süre içinde SATICI'ya faks, e-posta veya telefon ile bildirimde bulunulması ve ürünün ilgili madde hükümleri çercevesinde kullanılmamış olması şarttır. Bu hakkın kullanılması halinde, ürün/hizmet kullanımı ve erişimi derhal sonlandırılır ve takip eden 7 gün içinde ürün bedeli ALICI'ya iade edilir. </p>

                        <p>Niteliği itibarıyle iade edilemeyecek ürünler, tek kullanımlık ürünler, kopyalanabilir yazılım ve programlar, hızlı bozulan veya son kullanım tarihi geçen ürünler için cayma hakkı kullanılamaz. Her türlü yazılım ve programlar, DVD, VCD, CD ve kasetler, piller, sarf malzemeleri (toner, kartuş, şerit v.b) ve cayma hakkının kullanılması, ürünün ambalajının açılmamış, bozulmamış ve ürünün kullanılmamış olması şartına bağlıdır.</p>

                        <p>Ayrıca, tüketicinin özel istek ve talepleri uyarınca üretilen veya üzerinde değişiklik ya da ilaveler yapılarak kişiye özel hale getirilen mallarda tüketici cayma hakkını kullanamaz.</p>


                        <p><strong>DİĞER HUSUSLAR:</strong></p>

                        <p>Ödemenin kredi kartı veya benzeri bir ödeme kartı ile yapılması halinde tüketici, kartın kendi rızası dışında ve hukuka aykırı biçimde kullanıldığı gerekçesiyle ödeme işleminin iptal edilmesini talep edebilir. Bu halde, kartı çıkaran kuruluş itirazın kendisine bildirilmesinden itibaren 10 gün içinde ödeme tutarını tüketiciye iade eder.</p>

                        <p>Borçlunun temerrüde düşmesi halinde, Borçlu borcun gecikmeli ifasından dolayı alacaklının oluşan zarar ve ziyanını ödemeyi kabul eder.</p>

                        <p>İşbu sözleşmenin uygulanmasında, Sanayi ve Ticaret Bakanlığınca ilan edilen değere kadar Tüketici Hakem Heyetleri ile SATICI veya ALICI'nın yerleşim yerindeki Tüketici Mahkemeleri yetkilidir.</p>

                        <p>Siparişin sonuçlanması durumunda ALICI işbu sözleşmenin tüm koşullarını kabul etmiş sayılacaktır.</p>
							</div>
						</div>
					</div>

				</div>

				<section class="call-to-action call-to-action-default with-button-arrow call-to-action-in-footer">
					<div class="container">
						<div class="row">
							<div class="col-md-12">

							</div>
						</div>
					</div>
				</section>

			</div>
